var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"chart code examples"},[_c('h3',[_vm._v("Slope chart examples")]),_c('SlopeChartExampleBasic'),_c('SlopeChartExampleHighlight'),_c('SlopeChartExampleColors'),_c('SlopeChartExampleDataUpdate')],1)}
var staticRenderFns = []

export { render, staticRenderFns }